import React from 'react';
import PropTypes from 'prop-types';
import { CommonChrome } from '@solarwinds-cloud/cloud-ui';

export class SearchResultEntity extends React.PureComponent {
  static propTypes = {
    item: PropTypes.shape({
      edit_url: PropTypes.string,
      id: PropTypes.string,
      group_name: PropTypes.string,
      name: PropTypes.string,
      type: PropTypes.string,
    }).isRequired,
    searchPhrase: PropTypes.string.isRequired,
  };

  render() {
    const { item, searchPhrase } = this.props;
    let name = item.name;

    if (item.type === 'search' && item.group_name) {
      name += ` (${item.group_name})`;
    }

    return (
      <React.Fragment>
        <CommonChrome.NavSearch.Entity
          href={item.url}
          name={name}
          searchPhrase={searchPhrase}
        />
        {item.edit_url && (
          <CommonChrome.NavMenuButton
            className="edit-link"
            href={item.edit_url}
          >
            Edit
          </CommonChrome.NavMenuButton>
        )}
      </React.Fragment>
    );
  }
}
